import React, { useState } from 'react';
import { Colors, SmallIconButton } from 'library';
import { Message } from '@material-ui/icons';
import { Provider } from 'models';
import { track } from 'shared';
import { useHistory } from 'react-router-dom';
import { useUserContext } from 'UserContext';
import PublicMessagingModal from 'parent-portal/public/messages/PublicMessaging/PublicMessagingModal';
import usePublicSessionTracking, { PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';
import InternalMessagingBlockModal from './InternalMessagingBlockModal';

export default function MessageProviderAction({
    provider,
    location,
    shadow = false,
}: {
    provider: Provider;
    location: string;
    shadow?: boolean;
}) {
    const history = useHistory();
    const { user, hasPostedJob } = useUserContext();
    const [openPublicMessageModal, setOpenPublicMessageModal] = useState<boolean>(false);
    const [openMessageBlockModal, setOpenMessageBlockModal] = useState<boolean>(false);

    const { trackSession } = usePublicSessionTracking('Message Provider Action');

    function messageProvider() {
        let trackMessage = `${location}: Message Provider`;
        if (!!user && hasPostedJob) {
            history.push(`/messages/${provider.user.id}`);
        } else if (!!user && !hasPostedJob) {
            trackMessage = 'Blocked message provider dialog; no job posted';
            setOpenMessageBlockModal(true);
        } else {
            setOpenPublicMessageModal(true);
        }
        track(trackMessage);
        trackSession('DIALOG_OPEN', trackMessage, PublicSessionEventType.User, {
            providerId: provider.id,
        });
    }

    function closeDialog() {
        setOpenPublicMessageModal(false);
        trackSession('DIALOG_CLOSE', 'Closed message provider dialog', PublicSessionEventType.User, {
            providerId: provider.id,
        });
    }

    return (
        <>
            <SmallIconButton
                icon={Message}
                onClick={messageProvider}
                backgroundColor={Colors.white}
                shadow={shadow}
                hoverText="Message Provider"
                style={{ marginRight: 0 }}
            />
            <PublicMessagingModal
                provider={provider}
                open={openPublicMessageModal}
                close={closeDialog}
                location={'Provider card'}
            />
            <InternalMessagingBlockModal close={() => setOpenMessageBlockModal(false)} open={openMessageBlockModal} />
        </>
    );
}
